<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import "@/static/css/global.css";
import "@/static/css/application.css"
import "@/static/css/element-fix-forcely.css";
import "@/static/css/element.ui.custome.css";
import "@/static/css/cat.css";
import "animate.css";


export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style>
body {
  margin: 0px;
  padding-right: 0px !important;
}

body,
html {
  font-family: PingFangSC, helvetica neue, hiragino sans gb, arial,
    microsoft yahei ui, microsoft yahei, simsun, sans-serif !important;
}

#app {
  height: 100%;
  overflow: auto;
  background-color: rgb(228, 227, 239);
}

.fa,
.fab,
.fal,
.far,
.fas {
  font-size: 18px;
}

.fa-trash-alt {
  color: #f56c6c;
}

button[disabled="disabled"] .fa,
button[disabled="disabled"] .fab,
button[disabled="disabled"] .fal,
button[disabled="disabled"] .far,
button[disabled="disabled"] .fas {
  opacity: 0.5;
}

.button-no-padding {
  padding: 0px;
}

.common-topbar-user-info {
  display: none;
  float: right;
  padding: 0 10px 0;
  height: 60px;
  box-sizing: border-box;
  position: relative;
}

.common-topbar-user-image-wrapper:hover {
  background: #00c1de;
}

.common-topbar-user-info .common-topbar-user-image-wrapper {
  width: 40px;
  height: 40px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 100%;
  overflow: hidden;
  box-sizing: content-box;
}
.common-topbar-user-info .common-topbar-user-image-wrapper.small {
  width: 25px;
  height: 25px;
}

.common-topbar-user-info .common-topbar-user-image-wrapper img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.common-topbar-user-info-dropdown {
  position: fixed;
  right: 10px !important;
  top: 70px;
  width: 15.313rem;
  background: white;
  color: #333335;
  z-index: 99999;
  margin-top: -10px;
  box-shadow: 0 0.25rem 0.625rem rgba(20,20,20,.1);
  border-radius: 0.375rem;
}
.common-topbar-user-info-dropdown:after {
    content: "";
    position: absolute;
    top: -8.5px;
    inset-inline-end: 24px;
    border-bottom: 9px solid #763fcd;
    border-inline-start: 9px solid transparent;
    border-inline-end: 9px solid transparent;
}

.common-topbar-user-info-dropdown a {
  display: block;
  color: #333335;
  cursor: pointer;
  text-decoration: none;
}

.common-topbar-user-info-dropdown .top {
  background: linear-gradient(135deg, rgb(89, 101, 249) 0, #8039ca 100%);
  padding: 12px 16px;
  color: white;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  text-align: center;
}

.common-topbar-user-info-dropdown .top .top-line {
  font-size: 1.125rem;
}

.common-topbar-user-info-dropdown .top .top-line.short {
  height: 18px;
  line-height: 18px;
  margin-top: 4px;
}

.common-topbar-user-info-dropdown .top .user-uid {
  display: inline-block;
  width: 130px;
  font-size: 1.125rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: white;
  margin: 5px 0 0;
}

.common-topbar-user-info-dropdown .top .user-grade {
  float: right;
  display: block;
  width: 25px;
  text-align: center;
  color: white;
  transition: all 0.3s ease-in-out;
}

.common-topbar-user-info-dropdown .top .user-grade:hover {

}

.common-topbar-user-info-dropdown .info-prefix-icon {
  width: 16px;
  margin-right: 8px;
}

.common-topbar-user-info-dropdown .middle-line {
  padding: 10px 20px;
  font-size: .8125rem;
  position: relative;
  border-block-end: 1px solid #e7e7ef;
}

.common-topbar-user-info-dropdown .middle-line:hover {
  color: #409EFF;
}

.common-topbar-user-info-dropdown .middle-line .charge-btn {
  display: inline-block;
  border: 1px solid #ffa133;
  width: 40px;
  height: 20px;
  line-height: 20px;
  color: #ffa133;
  text-align: center;
  position: absolute;
  top: -1px;
  left: 75px;
}

.common-topbar-user-info-dropdown .middle-line .charge-btn:hover {
  background: #ffa133;
  color: #304156;
}

.common-topbar-user-info-dropdown .bottom-line {
  overflow: hidden;
  padding: 12px 16px 16px;
}

.common-topbar-user-info-dropdown .bottom-line .logout-btn {
  font-size: 12px;
  width: 70px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  float: right;
  border: 1px solid #73777a;
}

.common-topbar-user-info-dropdown .bottom-line .logout-btn:hover {
  border: 1px solid #00c1de;
}

.common-topbar-user-info-dropdown .bottom-line a,
.common-topbar-user-info-dropdown .bottom-line a:link,
.common-topbar-user-info-dropdown .bottom-line a:visited {
  color: #73777a;
}

.common-topbar-user-info-dropdown .bottom-line a:hover {
  color: #409EFF;
}

.menu-link {
  line-height: 40px;
  padding: 0 12px;
  color: white;
  float: right;
}

.menu-link > a {
  text-decoration: none;
  color: white;
  font-size: 14px;
}

.menu-link > a:hover {
  color: #00c1de;
}

.footer p.big {
  display: inline-block;
  font-size: 14px;
  font-weight: 200%;
  line-height: 21px;
  margin: 10px 20px;
}

.footer p.copyright {
  font-size: 14px;
  font-weight: 400%;
  line-height: 21px;
  color: #9b9ea0;
}

.footer p.big a {
  color: #9b9ea0;
  text-decoration-color: #9b9ea0;
  text-decoration-line: none;
  margin-right: 35px;
  border: none;
}

[v-cloak] {
  display: none;
}

.source {
  padding: 3px 0 3px 0px;
  margin-bottom: 8px;
}

.promotion {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.topDiv {
  height: 40px;
  top: 0;
  line-height: 34px;
  position: absolute;
  left: 200px;
  right: 20px;
}

.topText {
  float: left;
  color: #606266;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 3px;
}

.back {
  float: right;
  position: relative;
  z-index: 10;
  margin-top: 3px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
